"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDnsSuffix = void 0;
var getDnsSuffix_1 = require("./getDnsSuffix");
Object.defineProperty(exports, "getDnsSuffix", { enumerable: true, get: function () { return getDnsSuffix_1.getDnsSuffix; } });
